import { RocValues, RocResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// ROC = EBIT / (Long-term debt + Equity) * 100
export function calculateRoc(values: RocValues, t?: ToolsTranslations['roc']): RocResult {
  const { ebit, longTermDebt, equity } = values;

  if (ebit < 0) return { percent: null, isValid: false, message: t?.invalid.ebit };
  if (longTermDebt < 0) return { percent: null, isValid: false, message: t?.invalid.longTermDebt };
  if (equity <= 0) return { percent: null, isValid: false, message: t?.invalid.equity };

  const capital = longTermDebt + equity;
  if (capital <= 0) return { percent: null, isValid: false, message: t?.invalid.generic };

  const percent = Math.round((ebit / capital) * 100); // integer percent for display
  if (!isFinite(percent)) return { percent: null, isValid: false, message: t?.invalid.generic };
  return { percent, isValid: true };
}


